import React from 'react';
import type { ProductParameterGroupTypes } from '../../@sprinx/knihovka-types';
import {
  AfterPageProps,
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import preventAuth from '../../@sprinx/react-after-razzle/preventAuth';
import commonThingsToLoad from '../../api/commonThingsToLoad';
import {
  getProductParameterGroupTypes,
  productParameterGroupTypesInitialState,
} from '../../api/products/productParameterGroupTypes';
import ErrorInternal from '../../components/ErrorInternal';
import CartAsideLayout from '../../layouts/CartAsideLayout';
import FavoriteProductsPageLayout from './FavoriteProductsPageLayout';

type FavoriteProductsPageProps = AfterPageProps;

const FavoriteProductsPage = React.forwardRef<any, FavoriteProductsPageProps>(({ error /*, match */ }, ref) => {
  // const setCallParams = useSetRecoilState(catalogueCallParamsState);

  // React.useEffect(() => {
  //   setCallParams((prev) => {
  //     const txff = convertUrlToFilterField(match.url);
  //     const taxonomies = (typeof txff === 'function' && txff()?.taxonomies) || undefined;
  //     const prevTaxonomiesFn = prev.filter.find((ff) => typeof ff === 'function') as ToQuerySimple;
  //     const prevTaxonomies = (prevTaxonomiesFn && prevTaxonomiesFn()?.taxonomies) || undefined;
  //     const taxonomyIsSame = taxonomies && prevTaxonomies && taxonomies === prevTaxonomies;
  //     return taxonomyIsSame
  //       ? {
  //           ...prev,
  //           filter: [...prev.filter.filter((ff) => typeof ff !== 'function'), txff],
  //         }
  //       : {
  //           ...prev,
  //           filter: [...prev.filter.filter((ff: any) => ff.field === 'extraTaxonomies'), txff],
  //           pagination: {
  //             ...(prev.pagination || {}),
  //             page: 1,
  //           },
  //         };
  //   });
  // }, [match.url, setCallParams]);

  if (error) {
    return <ErrorInternal error={error} />;
  }

  return <FavoriteProductsPageLayout ref={ref} />;
});

FavoriteProductsPage.displayName = 'FavoriteProductsPage';

export default makeAfterComponent(
  wrapLayout(FavoriteProductsPage, CartAsideLayout),
  preventAuth(async ({ match, initialAppProps }) => {
    try {
      if (initialAppProps) {
        const appProps = initialAppProps;

        const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });

        const [parameterGroupTypes, ...commonThings] = (await Promise.all([
          getProductParameterGroupTypes(apiClient),
          ...commonThingsToLoad.promises({ apiClient }),
        ])) as [ProductParameterGroupTypes];

        appProps.propagateToState({
          ...commonThingsToLoad.toRegister(commonThings),
          [productParameterGroupTypesInitialState.key]: parameterGroupTypes,
        });

        // appProps.presaveState([catalogueCallParamsState.key]);
      }
      return {};
    } catch (error) {
      if (error.response?.status === 401) {
        return createInitialPropsRedirectToLogin({ match });
      }
      return { error };
    }
  }),
);
